
import { createAsyncThunk } from "@reduxjs/toolkit";
import { save_pharmasist_sign } from "../../../networking/urlEndPoints";
import { fetchPatientListWithoutPharmacistSign } from "./patientWithoutPharmacistSign";

import Axios from "../../../networking/interceptor";

export const UpdatePharmacistSignature = createAsyncThunk('UpdatePharmacistSignature', async (requestedData, { rejectWithValue }) => {

    const { pharmacist_id,
        signature,
        patient_id,
        setShowToast,
        pharmacy_id,
        dispatch,
        setLoading,
        consultation,
        flexi_rx_refill_id
    } = requestedData

    try {
        const uploadData = {
            pharmacy_id: pharmacy_id,
            signature: signature,
            patient_id: patient_id,
            pharmasist_id: pharmacist_id
        }

        if (consultation) {
            uploadData.counsult_text = consultation.value;
        }

        // if (flexi_rx_refill_id?.length > 0) {
        //     uploadData.flexi_rx_refill_id = flexi_rx_refill_id;
        // }

        const response = await Axios.post(save_pharmasist_sign, uploadData)
        const data = response.data

        return data;

    } catch (error) {
        if (typeof setShowToast === 'function') {
            setLoading(true)

            const params = {
                pharmacy_id: pharmacy_id,
                pharmacist_id: pharmacist_id,
                page: 1,
            }

            dispatch(fetchPatientListWithoutPharmacistSign(params))
            setShowToast(prevState => ({ ...prevState, errorToast: true }))

            setTimeout(() => {
                setShowToast(prevState => ({ ...prevState, errorToast: false }))
            }, 2000)

        }
        return rejectWithValue(error.response)
    }
})